


import React, { useState, useRef } from "react";
import { Container, Card, Form, Button, Spinner } from "react-bootstrap";
import { FiLock } from "react-icons/fi";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { useIDsContext } from "../../../context/IDsContext";
import { useMutation } from "react-query";
import api from "../../../utils/helper";
import { useAlerts } from "../../../context/AlertContext";

const OTPVerificationModal = ({ phoneNumber = "+91-999999999", onVerify, onCancel }) => {
    const [otp, setOtp] = useState(["", "", "", ""]);
    const [error, setError] = useState("");
    const inputRefs = [useRef(), useRef(), useRef(), useRef()];
    const location = useLocation();
    const navigate = useNavigate();


    // Get email and role from location state
    const { email, role } = location.state || {};

    const { login } = useAuth();
  const { showSuccess, showError } = useAlerts();
    const { setVendorID, setVendorName, setCollegeID, vendorID, collegeID } = useIDsContext();

    console.log(location.state, "mialn")


    const verifyOtpMutation = useMutation({
        mutationFn: (credentials) =>
            api.post("/auth/verify-otp", credentials, "vendor"),
        onSuccess: (response) => {
            setError("");
            localStorage.clear();
            console.log(response, "okokok");

            const userData = response?.data?.data?.user;

            // Store in localStorage
            localStorage.setItem("email", userData?.email);
            localStorage.setItem("profile_img", userData?.profile_img);
            login(
                response?.data?.data?.user?.firstname,
                "vendor",
                response?.data?.data?.token,
                response?.data?.data?.user?._id
            );
            setVendorID(response?.data?.data?.user?._id);
            setVendorName(response?.data?.data?.user?.name);
            navigate("/vendor/");
        },
        onError: (error) => {
            setError(error.message);
            // Clear OTP inputs on error
            setOtp(["", "", "", ""]);
            inputRefs[0].current?.focus();
        },
    });


    const handleVerify = () => {
        const otpString = otp.join("");

        // Validate OTP
        if (otpString.length !== 4) {
            setError("Please enter complete 4-digit OTP");
            return;
        }

        if (!email || !role) {
            setError("Missing email or role information");
            return;
        }

        // Call the mutation
        verifyOtpMutation.mutate({
            email,
            role,
            otp: otpString,
        });
    };

    const handleChange = (index, value) => {
        // Only allow numbers
        if (!/^\d*$/.test(value)) return;

        // Clear error when user starts typing
        if (error) setError("");

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Auto-focus next input
        if (value && index < 3) {
            inputRefs[index + 1].current.focus();
        }
    };

    const handleKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs[index - 1].current.focus();
        }
    };

    const handleResend = () => {
        // Implement resend logic here
        console.log("Resending OTP...");
        setError("");
        setOtp(["", "", "", ""]);
        inputRefs[0].current?.focus();
        sendOTPMutation.mutate(location.state)
    };

    const sendOTPMutation = useMutation({
        mutationFn: (credentials) =>
            api.post("/auth/send-otp", credentials, "teacher"),
        onSuccess: () => {
            // navigate("/teacher/otp-verification", { state: location.state })
            showSuccess("OTP sent successfully.")

        },

    });

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        } else {
            // Default behavior - navigate back
            navigate(-1);
        }
    };

    return (
        <Container
            fluid
            className="d-flex justify-content-center align-items-center vh-100"
        >
            <Card className="otp-modal">
                <Card.Body className="otp-modal__body">
                    {/* Lock Icon */}
                    <div className="text-center mb-3">
                        <div className="phone-modal__icon-wrapper">
                            <FiLock className="phone-modal__lock-icon" />
                        </div>
                    </div>


                    {/* Title */}
                    <h6 className="phone-modal__title">
                        Please check your mail box
                    </h6>

                    {/* Subtitle */}
                    <p className="phone-modal__subtitle">
                        We've sent a code to <span className="bold-600">{email}</span>
                    </p>

                    {/* OTP Input Group */}
                    <div className="d-flex justify-content-center gap-2 mb-1">
                        {otp.map((digit, index) => (
                            <Form.Control
                                key={index}
                                ref={inputRefs[index]}
                                type="text"
                                maxLength={1}
                                value={digit}
                                onChange={(e) => handleChange(index, e.target.value)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                className="otp-modal__input text-center"
                                style={{ width: "60px", height: "60px", fontSize: "24px" }}
                            />
                        ))}
                    </div>

                    {/* Resend Link */}
                    <div className="text-center mb-4">
                        <span className="otp-modal__resend-text">
                            Didn't get a code?{" "}
                            <Button
                                variant="link"
                                className="otp-modal__resend-button p-0"
                                onClick={handleResend}
                            >
                                Click to resend
                            </Button>
                        </span>
                    </div>

                    {verifyOtpMutation?.error && (
                        <p className="text-danger family-inter">
                            {verifyOtpMutation?.error?.response?.data?.message ||
                                "Error while sending OTP!"}
                        </p>
                    )}

                    {/* Action Buttons */}
                    <div className="d-flex gap-3">
                        <Button
                            variant="outline-secondary"
                            className="flex-grow-1"
                            onClick={handleCancel}
                            disabled={verifyOtpMutation.isLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            className="flex-grow-1"
                            onClick={handleVerify}
                            disabled={verifyOtpMutation.isLoading}
                        >
                            {verifyOtpMutation.isLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Verifying...
                                </>
                            ) : (
                                "Verify"
                            )}
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default OTPVerificationModal;